import { render, staticRenderFns } from "./oa-rate-rebrand.vue?vue&type=template&id=4fe1cf26&"
import script from "./oa-rate-rebrand.vue?vue&type=script&lang=js&"
export * from "./oa-rate-rebrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports